import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    name: localStorage.getItem('user_name') || '',
    role: Number(localStorage.getItem('user_role')) || null,
    token: localStorage.getItem('auth_token') || '',
  }),
  actions: {
    setUser({ name, role, token }) {
      this.name = name;
      this.role = role;
      this.token = token;
      localStorage.setItem('user_name', name);
      localStorage.setItem('user_role', role);
      localStorage.setItem('auth_token', token);
    },
    clearUser() {
      this.name = '';
      this.role = null;
      this.token = '';
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_role');
      localStorage.removeItem('auth_token');
    }
  }
});